// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1-I2y","footer":"ModalCreateQualiphyProcedure_footer__2zYK2","additionData":"ModalCreateQualiphyProcedure_additionData__3IjfM"};